/**
 * Skill files — types for the dedicated `/api/v1/skills/{skillId}/files`
 * routes.
 *
 * Unlike the unified VFS (`/api/v1/vfs/{ownerId}`), the skill-files API is
 * org-scoped by `skillId` alone, uses inline base64 upload, and returns a
 * leaner ref with no `fileId` — files are addressed by `path`. Folder refs
 * carry `contentType: "inode/directory"`.
 */

/** One file (or folder) ref as returned by the skill-files list endpoint. */
export interface SkillFileRef {
  /** Path within the skill, may contain "/". */
  path: string;
  /** MIME type; folder refs use "inode/directory". */
  contentType: string;
  sizeBytes: number;
  /** S3 ETag. */
  checksum: string;
}

/** Content type the backend uses to mark a folder ref. */
export const SKILL_FOLDER_CONTENT_TYPE = 'inode/directory';
